import React, { useState } from "react";
import api from "../api";
import InlineAlert from "../ui/InlineAlert";
import { packageActionLabel, packagePrice, smallestPackage } from "./workspaceOverviewModel";

export default function ReviewCreditPurchase({
  packages = [],
  canPurchase = false,
  purchasesEnabled = false,
  compact = false,
}) {
  const [selectedId, setSelectedId] = useState("");
  const [buying, setBuying] = useState(false);
  const [error, setError] = useState("");
  const ordered = [...packages].sort((left, right) => Number(left.credits) - Number(right.credits) || Number(left.priceCents) - Number(right.priceCents));
  const preferred = smallestPackage(ordered);
  const selected = ordered.find((item) => item.id === (selectedId || preferred?.id)) || preferred;

  async function buy() {
    if (!selected || buying) return;
    setBuying(true);
    setError("");
    try {
      const response = await api.post("/billing/review-credit-checkout", { packageId: selected.id });
      const url = response?.data?.url;
      if (!url) throw new Error("Checkout did not start.");
      try {
        window.location.assign(url);
      } catch {
        setBuying(false);
      }
    } catch (err) {
      setError(err?.response?.data?.error || "Checkout could not be started.");
      setBuying(false);
    }
  }

  if (!purchasesEnabled || !canPurchase) return null;
  if (!selected) return <p className="rr-muted">Review packages are not available right now.</p>;

  return (
    <div className={compact ? "rr-credit-purchase is-compact" : "rr-credit-purchase"}>
      <div className="rr-package-picker" role="group" aria-label="Review package">
        {ordered.map((item) => (
          <button
            key={item.id}
            type="button"
            aria-pressed={item.id === selected.id}
            onClick={() => setSelectedId(item.id)}
          >
            {item.credits} · {packagePrice(item.priceCents)}
          </button>
        ))}
      </div>
      <button type="button" className="rr-button" onClick={buy} disabled={buying}>
        {buying ? "Opening checkout…" : packageActionLabel(selected)}
      </button>
      {error ? <InlineAlert tone="alert">{error}</InlineAlert> : null}
    </div>
  );
}
